import { requestPayloadBodyFormate, responseDataFormate } from "../../helpers/bycrypt";
import { catchHandler, dispatchError, dispatchLoading, dispatchToast, elseHandler } from "../../helpers/dispatch";
import { AppDispatch } from "../../store";
import { API_URL } from "../../helpers/utils";
import axios from "../../helpers/axios";
const APK_API_URL = `${API_URL}`;

interface GetBoatsForListingProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  search?: string;
  location?: string;
  created_at_start?: string;
  created_at_end?: string;
  updated_at_start?: string;
  updated_at_end?: string;
  order?: string;
  is_active?: number;
  id?: string;
  populate?: any;
  make?: string;
  customer_id?: string;
}

export const GetBoatsForListingAPI =
  ({
    page,
    limit,
    setHasMore,
    search,
    location,
    created_at_start,
    created_at_end,
    updated_at_start,
    updated_at_end,
    order,
    is_active,
    id,
    populate,
    make,
    customer_id,
  }: GetBoatsForListingProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getBoatsForListing", true);
    try {
      const response = await axios.get(`${APK_API_URL}/boat/list`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          location: location,
          created_at_start: created_at_start,
          created_at_end: created_at_end,
          updated_at_start: updated_at_start,
          updated_at_end: updated_at_end,
          order: order,
          is_active: is_active,
          id: id,
          populate: populate,
          make: make,
          customer_id: customer_id,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getBoatsForListing", undefined);
        dispatchLoading(dispatch, "getBoatsForListing", false);

        return result;
      } else {
        elseHandler(dispatch, "getBoatsForListing", result);
        dispatchLoading(dispatch, "getBoatsForListing", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getBoatsForListing")(e);
      dispatchLoading(dispatch, "getBoatsForListing", false);
    }
  };

export const AssignChecklistsToBoatAPI = (data: any, onClose?: any) => (dispatch: AppDispatch) => {
  dispatchLoading(dispatch, "AssignChecklistToBoat", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .put(`${APK_API_URL}/checklist/assign-boat`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AssignChecklistToBoat", undefined);
      } else elseHandler(dispatch, "AssignChecklistToBoat", result);
      dispatchLoading(dispatch, "AssignChecklistToBoat", false);
    })
    .catch((e) => {
      catchHandler(dispatch, "AssignChecklistToBoat")(e);
    })
    .finally(() => {
      if (onClose) onClose();
    });
};

interface GetMakeListForFilterProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  id?: string;
  search?: string;
  created_at_start?: string;
  created_at_end?: string;
  updated_at_start?: string;
  updated_at_end?: string;
  is_active?: number;
  business: string;
}

export const GetMakeListAPI =
  ({
    page,
    limit,
    setHasMore,
    search,
    created_at_start,
    created_at_end,
    updated_at_start,
    updated_at_end,
    is_active,
    id,
    business,
  }: GetMakeListForFilterProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getMakeListForFilter", true);
    try {
      const response = await axios.get(`${APK_API_URL}/static-data/boat-make`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          created_at_start: created_at_start,
          created_at_end: created_at_end,
          updated_at_start: updated_at_start,
          updated_at_end: updated_at_end,
          is_active: is_active,
          id: id,
          business: business,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getMakeListForFilter", undefined);
        dispatchLoading(dispatch, "getMakeListForFilter", false);

        return result;
      } else {
        elseHandler(dispatch, "getMakeListForFilter", result);
        dispatchLoading(dispatch, "getMakeListForFilter", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getMakeListForFilter")(e);
      dispatchLoading(dispatch, "getMakeListForFilter", false);
    }
  };

export const ManageChecklistsForBoatAPI = (data: any, onClose?: any) => (dispatch: AppDispatch) => {
  dispatchLoading(dispatch, "ManageChecklistForBoat", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .post(`${APK_API_URL}/checklist/manage-checklist`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "ManageChecklistForBoat", undefined);
      } else elseHandler(dispatch, "ManageChecklistForBoat", result);
      dispatchLoading(dispatch, "ManageChecklistForBoat", false);
    })
    .catch((e) => {
      catchHandler(dispatch, "ManageChecklistForBoat")(e);
    })
    .finally(() => {
      if (onClose) onClose();
    });
};

export const CreateBoatMakeAPIWithoutRefetch = (data: any, onClose: any) => (dispatch: AppDispatch) => {
  dispatchLoading(dispatch, "createBoatMake", true);
  const formatedData = requestPayloadBodyFormate(data);
  axios
    .post(`${APK_API_URL}/static-data/boat-make`, formatedData, {
      withCredentials: true,
    })
    .then((response) => {
      let result = responseDataFormate(response.data);
      if (result?.success) {
        onClose();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "createBoatMake", undefined);
      } else elseHandler(dispatch, "createBoatMake", result);
      dispatchLoading(dispatch, "createBoatMake", false);
    })
    // .catch(catchHandler(dispatch,"createBoatMake"));
    .catch((e) => {
      catchHandler(dispatch, "createBoatMake")(e);
    });
};

export const AddBoatAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddBoatAPI", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/boat`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddBoatAPI", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddBoatAPI", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddBoatAPI")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddBoatAPI", false);
    }
  };

export const UpdateBoatAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateBoat", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/boat`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateBoat", undefined);
        return result;
      } else {
        elseHandler(dispatch, "UpdateBoat", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateBoat")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "UpdateBoat", false);
    }
  };

export const ChangeBoatStatusAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "ChangeBoatStatus", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/boat/active`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "ChangeBoatStatus", undefined);
        return result;
      } else {
        elseHandler(dispatch, "ChangeBoatStatus", result);
      }
    } catch (e) {
      catchHandler(dispatch, "ChangeBoatStatus")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "ChangeBoatStatus", false);
    }
  };

export const DeleteBoatAPI =
  (data: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteBoat", true);

    try {
      const formattedData = requestPayloadBodyFormate(data);
      const response = await axios.delete(`${APK_API_URL}/boat`, {
        data: formattedData,
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteBoat", undefined);
      } else {
        elseHandler(dispatch, "DeleteBoat", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteBoat")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteBoat", false);
      onClose?.();
    }
  };

interface GetCustomersAPIProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  id?: string;
  search?: string;
  location?: string;
  created_at_start?: string;
  created_at_end?: string;
  updated_at_start?: string;
  updated_at_end?: string;
  is_active?: number;
  order?: string;
  populate?: string;
  email?: string;
}

export const GetCustomersAPI =
  ({
    page,
    limit,
    setHasMore,
    search,
    location,
    created_at_start,
    created_at_end,
    updated_at_start,
    updated_at_end,
    order,
    is_active,
    id,
    populate,
    email,
  }: GetCustomersAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getCustomers", true);
    try {
      const response = await axios.get(`${APK_API_URL}/customer`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          location: location,
          created_at_start: created_at_start,
          created_at_end: created_at_end,
          updated_at_start: updated_at_start,
          updated_at_end: updated_at_end,
          order: order,
          is_active: is_active,
          id: id,
          populate: populate,
          email: email,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getCustomers", undefined);
        dispatchLoading(dispatch, "getCustomers", false);

        return result;
      } else {
        elseHandler(dispatch, "getCustomers", result);
        dispatchLoading(dispatch, "getCustomers", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getCustomers")(e);
      dispatchLoading(dispatch, "getCustomers", false);
    }
  };

interface GetInventoryAPIProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  search?: string;
  category?: string;
  start_date?: string;
  end_date?: string;
  id?: string;
  barcode?: string;
  sku?: string;
  sortBy?: string;
  sortOrder?: string;
}

export const GetInventoryAPI =
  ({
    page,
    limit,
    setHasMore,
    search,
    category,
    start_date,
    end_date,
    barcode,
    sku,
    sortBy,
    id,
    sortOrder,
  }: GetInventoryAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getInventory", true);
    try {
      const response = await axios.get(`${APK_API_URL}/inventory`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          category: category,
          start_date: start_date,
          end_date: end_date,
          barcode: barcode,
          sku: sku,
          sortBy: sortBy,
          id: id,
          sortOrder: sortOrder,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getInventory", undefined);
        dispatchLoading(dispatch, "getInventory", false);

        return result;
      } else {
        elseHandler(dispatch, "getInventory", result);
        dispatchLoading(dispatch, "getInventory", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getInventory")(e);
      dispatchLoading(dispatch, "getInventory", false);
    }
  };

export const AddBoatComponentAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddBoatComponentAPI", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/boat/components`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddBoatComponentAPI", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddBoatComponentAPI", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddBoatComponentAPI")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddBoatComponentAPI", false);
    }
  };

export const UpdateBoatComponentAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateBoatComponent", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/boat/components`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateBoatComponent", undefined);
        return result;
      } else {
        elseHandler(dispatch, "UpdateBoatComponent", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateBoatComponent")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "UpdateBoatComponent", false);
    }
  };

interface GetBoatComponentsAPIProps {
  id?: string;
  boat?: string;
  page?: number;
  limit?: number;
  search?: string;
}

export const GetBoatComponentsAPI =
  ({ id, boat, page, limit, search }: GetBoatComponentsAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getBoatsForListing", true);
    try {
      const response = await axios.get(`${APK_API_URL}/boat/components`, {
        params: {
          id: id,
          boat: boat,
          page: page,
          limit: limit,
          search: search,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        dispatchError(dispatch, "getBoatsForListing", undefined);
        dispatchLoading(dispatch, "getBoatsForListing", false);

        return result;
      } else {
        elseHandler(dispatch, "getBoatsForListing", result);
        dispatchLoading(dispatch, "getBoatsForListing", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getBoatsForListing")(e);
      dispatchLoading(dispatch, "getBoatsForListing", false);
    }
  };

export const DeleteBoatComponentAPI =
  (data: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteBoatComponent", true);

    try {
      const formattedData = requestPayloadBodyFormate(data);
      const response = await axios.delete(`${APK_API_URL}/boat/components`, {
        data: formattedData,
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteBoatComponent", undefined);
      } else {
        elseHandler(dispatch, "DeleteBoatComponent", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteBoatComponent")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteBoatComponent", false);
      onClose?.();
    }
  };

export const AddBoatPreviousNameAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddBoatPreviousName", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/boat-previous-names`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddBoatPreviousName", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddBoatPreviousName", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddBoatPreviousName")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddBoatPreviousName", false);
    }
  };

interface GetBoatPreviosNamesListingProps {
  boat: string;
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
}

export const GetBoatPreviousNamesAPI =
  ({ page, limit, setHasMore, boat }: GetBoatPreviosNamesListingProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getBoatsForListing", true);
    try {
      const response = await axios.get(`${APK_API_URL}/boat-previous-names`, {
        params: {
          page: page,
          limit: limit,
          boat: boat,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getBoatsForListing", undefined);
        dispatchLoading(dispatch, "getBoatsForListing", false);

        return result;
      } else {
        elseHandler(dispatch, "getBoatsForListing", result);
        dispatchLoading(dispatch, "getBoatsForListing", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getBoatsForListing")(e);
      dispatchLoading(dispatch, "getBoatsForListing", false);
    }
  };

export const UpdateBoatPreviousNameAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateBoatPreviousName", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/boat-previous-names`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateBoatPreviousName", undefined);
        return result;
      } else {
        elseHandler(dispatch, "UpdateBoatPreviousName", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateBoatPreviousName")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "UpdateBoatPreviousName", false);
    }
  };

export const DeleteBoatPreviousNameAPI =
  (data: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteBoatPreviousName", true);

    try {
      const formattedData = requestPayloadBodyFormate(data);
      const response = await axios.delete(`${APK_API_URL}/boat-previous-names`, {
        data: formattedData,
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteBoatPreviousName", undefined);
      } else {
        elseHandler(dispatch, "DeleteBoatPreviousName", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteBoatPreviousName")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteBoatPreviousName", false);
      onClose?.();
    }
  };

export const AddHaulPlanAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddHaulPlanAPI", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/haul-plan`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddHaulPlanAPI", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddHaulPlanAPI", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddHaulPlanAPI")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddHaulPlanAPI", false);
    }
  };

interface GetHaulPlanAPIProps {
  boat_id?: string;
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  order?: string;
}

export const GetHaulPlanAPI =
  ({ page, limit, setHasMore, order, boat_id }: GetHaulPlanAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getCustomers", true);
    try {
      const response = await axios.get(`${APK_API_URL}/haul-plan`, {
        params: {
          page: page,
          limit: limit,
          order: order,
          boat_id: boat_id,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getCustomers", undefined);
        dispatchLoading(dispatch, "getCustomers", false);

        return result;
      } else {
        elseHandler(dispatch, "getCustomers", result);
        dispatchLoading(dispatch, "getCustomers", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getCustomers")(e);
      dispatchLoading(dispatch, "getCustomers", false);
    }
  };

export const UpdateHaulPlanAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateHaulPlan", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/haul-plan`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateHaulPlan", undefined);
        return result;
      } else {
        elseHandler(dispatch, "UpdateHaulPlan", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateHaulPlan")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "UpdateHaulPlan", false);
    }
  };

export const DeleteHaulPlanAPI =
  (haul_id: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteHaulPlan", true);

    try {
      const response = await axios.delete(`${APK_API_URL}/haul-plan`, {
        params: {
          haul_id: haul_id,
        },
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteHaulPlan", undefined);
      } else {
        elseHandler(dispatch, "DeleteHaulPlan", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteHaulPlan")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteHaulPlan", false);
      onClose?.();
    }
  };

export const AddStoragePlanAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddStoragePlanAPI", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/storage-plan`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddStoragePlanAPI", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddStoragePlanAPI", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddStoragePlanAPI")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddStoragePlanAPI", false);
    }
  };

interface GetStoragePlanAPIProps {
  boat_id: string;
}

export const GetStoragePlanAPI =
  ({ boat_id }: GetStoragePlanAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getStoragePlan", true);
    try {
      const response = await axios.get(`${APK_API_URL}/storage-plan`, {
        params: {
          boat_id: boat_id,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        dispatchError(dispatch, "getStoragePlan", undefined);
        dispatchLoading(dispatch, "getStoragePlan", false);

        return result;
      } else {
        elseHandler(dispatch, "getStoragePlan", result);
        dispatchLoading(dispatch, "getStoragePlan", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getStoragePlan")(e);
      dispatchLoading(dispatch, "getStoragePlan", false);
    }
  };

interface GetDinghyAPIProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  id?: string;
  search?: string;
  created_at_start?: string;
  created_at_end?: string;
  updated_at_start?: string;
  updated_at_end?: string;
  is_active?: string;
}

export const GetDinghyMakeListAPI =
  ({
    page,
    limit,
    setHasMore,
    search,
    created_at_start,
    created_at_end,
    updated_at_start,
    updated_at_end,
    is_active,
    id,
  }: GetDinghyAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getDinghyMakeList", true);
    try {
      const response = await axios.get(`${APK_API_URL}/static-data/dinghy-make`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          created_at_start: created_at_start,
          created_at_end: created_at_end,
          updated_at_start: updated_at_start,
          updated_at_end: updated_at_end,
          is_active: is_active,
          id: id,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getDinghyMakeList", undefined);
        dispatchLoading(dispatch, "getDinghyMakeList", false);

        return result;
      } else {
        elseHandler(dispatch, "getDinghyMakeList", result);
        dispatchLoading(dispatch, "getDinghyMakeList", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getDinghyMakeList")(e);
      dispatchLoading(dispatch, "getDinghyMakeList", false);
    }
  };

export const AddDinghyMakeAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddDinghyMake", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/static-data/dinghy-make`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddDinghyMake", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddDinghyMake", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddDinghyMake")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddDinghyMake", false);
    }
  };

export const AddDinghyAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddDinghy", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/mast-dinghy/dinghy`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddDinghy", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddDinghy", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddDinghy")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddDinghy", false);
    }
  };

export const UpdateDinghyAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateDinghy", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/mast-dinghy/dinghy`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateDinghy", undefined);
        return result;
      } else {
        elseHandler(dispatch, "UpdateDinghy", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateDinghy")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "UpdateDinghy", false);
    }
  };

interface GetDinghyListingProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  boat_id?: string;
  search?: string;
  search_name?: string;
}

export const GetDinghyListAPI =
  ({ page, limit, setHasMore, boat_id, search, search_name }: GetDinghyListingProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getDinghyListing", true);
    try {
      const response = await axios.get(`${APK_API_URL}/mast-dinghy/dinghy`, {
        params: {
          page: page,
          limit: limit,
          boat_id: boat_id,
          search: search,
          search_name: search_name,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getDinghyListing", undefined);
        dispatchLoading(dispatch, "getDinghyListing", false);

        return result;
      } else {
        elseHandler(dispatch, "getDinghyListing", result);
        dispatchLoading(dispatch, "getDinghyListing", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getDinghyListing")(e);
      dispatchLoading(dispatch, "getDinghyListing", false);
    }
  };

export const DeleteDinghyAPI =
  (boat_dinghy_id: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteDinghy", true);

    try {
      const response = await axios.delete(`${APK_API_URL}/mast-dinghy/dinghy`, {
        params: {
          boat_dinghy_id: boat_dinghy_id,
        },
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteDinghy", undefined);
      } else {
        elseHandler(dispatch, "DeleteDinghy", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteDinghy")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteDinghy", false);
      onClose?.();
    }
  };

export const GetMastIdForAddition =
  (boat_id?: string) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getMastId", true);
    try {
      const response = await axios.get(`${APK_API_URL}/mast-dinghy/last-mast/id`, {
        params: {
          boat_id: boat_id,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        dispatchError(dispatch, "getMastId", undefined);
        dispatchLoading(dispatch, "getMastId", false);

        return result;
      } else {
        elseHandler(dispatch, "getMastId", result);
        dispatchLoading(dispatch, "getMastId", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getMastId")(e);
      dispatchLoading(dispatch, "getMastId", false);
    }
  };

export const AddMastAPI =
  (data: any, onClose?: any, onError?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddMast", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/mast-dinghy`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddMast", undefined);
        if (onClose) onClose();
        return result;
      } else {
        elseHandler(dispatch, "AddMast", result);
      }
    } catch (e) {
      if (onError) onError();
      catchHandler(dispatch, "AddMast")(e);
    }
  };

export const UpdateMastAPI =
  (data: any, onClose?: any, onError?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateMast", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/mast-dinghy`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateMast", undefined);
        if (onClose) onClose();
        return result;
      } else {
        elseHandler(dispatch, "UpdateMast", result);
      }
    } catch (e) {
      if (onError) onError();
      catchHandler(dispatch, "UpdateMast")(e);
    }
  };

interface GetMastsListingProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  boat_id: string;
  stand_order?: string;
  equipment_order?: string;
  search?: string;
}

export const GetMastListAPI =
  ({ page, limit, setHasMore, boat_id, stand_order, equipment_order, search }: GetMastsListingProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getMastListing", true);
    try {
      const response = await axios.get(`${APK_API_URL}/mast-dinghy`, {
        params: {
          page: page,
          limit: limit,
          boat_id: boat_id,
          stand_order: stand_order,
          equipment_order: equipment_order,
          search: search,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getMastListing", undefined);
        dispatchLoading(dispatch, "getMastListing", false);

        return result;
      } else {
        elseHandler(dispatch, "getMastListing", result);
        dispatchLoading(dispatch, "getMastListing", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getMastListing")(e);
      dispatchLoading(dispatch, "getMastListing", false);
    }
  };

export const DeleteMastAPI =
  (boat_mast_id: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteMast", true);

    try {
      const response = await axios.delete(`${APK_API_URL}/mast-dinghy`, {
        params: {
          boat_mast_id: boat_mast_id,
        },
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteMast", undefined);
      } else {
        elseHandler(dispatch, "DeleteMast", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteMast")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteMast", false);
      onClose?.();
    }
  };

export const GetRiggingIdForAddition =
  () =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "GetRiggingId", true);
    try {
      const response = await axios.get(`${APK_API_URL}/mast-dinghy/last-stand-rig/id`, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        dispatchError(dispatch, "GetRiggingId", undefined);
        dispatchLoading(dispatch, "GetRiggingId", false);

        return result;
      } else {
        elseHandler(dispatch, "GetRiggingId", result);
        dispatchLoading(dispatch, "GetRiggingId", false);
      }
    } catch (e) {
      catchHandler(dispatch, "GetRiggingId")(e);
      dispatchLoading(dispatch, "GetRiggingId", false);
    }
  };

export const AddRiggingAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddRigging", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/mast-dinghy/stand-rig`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddRigging", undefined);
        if (onClose) onClose(result);
        return result;
      } else {
        elseHandler(dispatch, "AddRigging", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddRigging")(e);
    } finally {
      dispatchLoading(dispatch, "AddRigging", false);
    }
  };

export const UpdateRiggingAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateRigging", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/mast-dinghy/stand-rig`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateRigging", undefined);
        if (onClose) onClose(result);
        return result;
      } else {
        elseHandler(dispatch, "UpdateRigging", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateRigging")(e);
    } finally {
      dispatchLoading(dispatch, "UpdateRigging", false);
    }
  };

export const DeleteRiggingAPI =
  (stand_id: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteRigging", true);

    try {
      const response = await axios.delete(`${APK_API_URL}/mast-dinghy/stand-rig`, {
        params: {
          stand_id: stand_id,
        },
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteRigging", undefined);
      } else {
        elseHandler(dispatch, "DeleteRigging", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteRigging")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteRigging", false);
      onClose?.();
    }
  };

export const AddEquipmentAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddEquipment", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/mast-dinghy/equipment`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddEquipment", undefined);
        if (onClose) onClose(result);
        return result;
      } else {
        elseHandler(dispatch, "AddEquipment", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddEquipment")(e);
    } finally {
      dispatchLoading(dispatch, "AddEquipment", false);
    }
  };

export const UpdateEquipmentAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateEquipment", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/mast-dinghy/equipment`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateEquipment", undefined);
        if (onClose) onClose(result);
        return result;
      } else {
        elseHandler(dispatch, "UpdateEquipment", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateEquipment")(e);
    } finally {
      dispatchLoading(dispatch, "UpdateEquipment", false);
    }
  };

export const DeleteEquipmentAPI =
  (equipment_id: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteEquipment", true);

    try {
      const response = await axios.delete(`${APK_API_URL}/mast-dinghy/equipment`, {
        params: {
          equipment_id: equipment_id,
        },
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteEquipment", undefined);
      } else {
        elseHandler(dispatch, "DeleteEquipment", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteEquipment")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteEquipment", false);
      onClose?.();
    }
  };

interface GetBoatItemCategoryAPIProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  id?: string;
  search?: string;
  created_at_start?: string;
  created_at_end?: string;
  updated_at_start?: string;
  updated_at_end?: string;
  is_active?: string;
}

export const GetBoatItemCategoriesAPI =
  ({
    page,
    limit,
    setHasMore,
    id,
    search,
    created_at_start,
    created_at_end,
    updated_at_start,
    updated_at_end,
    is_active,
  }: GetBoatItemCategoryAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getBoatItemCategories", true);
    try {
      const response = await axios.get(`${APK_API_URL}/static-data/boat-item`, {
        params: {
          page: page,
          limit: limit,
          id: id,
          created_at_start: created_at_start,
          created_at_end: created_at_end,
          search: search,
          updated_at_start: updated_at_start,
          updated_at_end: updated_at_end,
          is_active: is_active,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getBoatItemCategories", undefined);
        dispatchLoading(dispatch, "getBoatItemCategories", false);

        return result;
      } else {
        elseHandler(dispatch, "getBoatItemCategories", result);
        dispatchLoading(dispatch, "getBoatItemCategories", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getBoatItemCategories")(e);
      dispatchLoading(dispatch, "getBoatItemCategories", false);
    }
  };

export const AddBoatItemCategoryAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddBoatItemCategory", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/static-data/boat-item`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddBoatItemCategory", undefined);
        if (onClose) onClose(result);
        return result;
      } else {
        elseHandler(dispatch, "AddBoatItemCategory", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddBoatItemCategory")(e);
    } finally {
      dispatchLoading(dispatch, "AddBoatItemCategory", false);
    }
  };

export const GetBoatItemIdForAddition =
  ({ boatId }) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getBoatItemId", true);
    try {
      const response = await axios.get(`${APK_API_URL}/boat-item/last-boat-item/id`, {
        params: {
          boat_id: boatId,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        dispatchError(dispatch, "getBoatItemId", undefined);
        dispatchLoading(dispatch, "getBoatItemId", false);

        return result;
      } else {
        elseHandler(dispatch, "getBoatItemId", result);
        dispatchLoading(dispatch, "getBoatItemId", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getBoatItemId")(e);
      dispatchLoading(dispatch, "getBoatItemId", false);
    }
  };

export const AddBoatItemAPI =
  (data: any, onSuccess?: any, onError?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddBoatItem", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/boat-item`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddBoatItem", undefined);
        if (onSuccess) onSuccess(result);
        return result;
      } else {
        elseHandler(dispatch, "AddBoatItem", result);
      }
    } catch (e) {
      if (onError) onError();
      catchHandler(dispatch, "AddBoatItem")(e);
    } finally {
      dispatchLoading(dispatch, "AddBoatItem", false);
    }
  };

interface GetBoatItemsListingProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  search?: string;
  boat_id: string;
  order?: string;
  category?: string;
}

export const GetBoatItemsListAPI =
  ({ page, limit, setHasMore, boat_id, order, category, search }: GetBoatItemsListingProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getMastListing", true);
    try {
      const response = await axios.get(`${APK_API_URL}/boat-item`, {
        params: {
          page: page,
          limit: limit,
          boat_id: boat_id,
          order: order,
          category: category,
          search: search,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getMastListing", undefined);
        dispatchLoading(dispatch, "getMastListing", false);

        return result;
      } else {
        elseHandler(dispatch, "getMastListing", result);
        dispatchLoading(dispatch, "getMastListing", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getMastListing")(e);
      dispatchLoading(dispatch, "getMastListing", false);
    }
  };

export const UpdateBoatItemAPI =
  (data: any, onSuccess?: any, onError?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateBoatItem", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/boat-item`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateBoatItem", undefined);
        if (onSuccess) onSuccess(result);
        return result;
      } else {
        elseHandler(dispatch, "UpdateBoatItem", result);
      }
    } catch (e) {
      if (onError) onError();
      catchHandler(dispatch, "UpdateBoatItem")(e);
    } finally {
      dispatchLoading(dispatch, "UpdateBoatItem", false);
    }
  };

export const DeleteItemPI =
  (boat_item_id: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteItem", true);

    try {
      const response = await axios.delete(`${APK_API_URL}/boat-item`, {
        params: {
          boat_item_id: boat_item_id,
        },
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteItem", undefined);
      } else {
        elseHandler(dispatch, "DeleteItem", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteItem")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteItem", false);
      onClose?.();
    }
  };

interface GetBoatStorageContractAPIProps {
  boat_id: string;
  search?: string;
}

export const GetBoatStorageContractsAPI =
  ({ boat_id, search }: GetBoatStorageContractAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getBoatStorageContracts", true);
    try {
      const response = await axios.get(`${APK_API_URL}/boat/store-contract`, {
        params: {
          boat_id: boat_id,
          search: search,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        dispatchError(dispatch, "getBoatStorageContracts", undefined);
        dispatchLoading(dispatch, "getBoatStorageContracts", false);

        return result;
      } else {
        elseHandler(dispatch, "getBoatStorageContracts", result);
        dispatchLoading(dispatch, "getBoatStorageContracts", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getBoatStorageContracts")(e);
      dispatchLoading(dispatch, "getBoatStorageContracts", false);
    }
  };

export const GetCategoriesForBoatItemsFilterAPI =
  () =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getCategoriesForFilter", true);
    try {
      const response = await axios.get(`${APK_API_URL}/boat-item/get-unique-category`, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        dispatchError(dispatch, "getCategoriesForFilter", undefined);
        dispatchLoading(dispatch, "getCategoriesForFilter", false);

        return result;
      } else {
        elseHandler(dispatch, "getCategoriesForFilter", result);
        dispatchLoading(dispatch, "getCategoriesForFilter", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getCategoriesForFilter")(e);
      dispatchLoading(dispatch, "getCategoriesForFilter", false);
    }
  };

export const AddHaulCompanyAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddHaulCompanyAPI", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/static-data/haul-company`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddHaulCompanyAPI", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddHaulCompanyAPI", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddHaulCompanyAPI")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddHaulCompanyAPI", false);
    }
  };

interface GetHaulComapniesAPIProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  id?: string;
  search?: string;
  created_at_start?: string;
  created_at_end?: string;
  updated_at_start?: string;
  updated_at_end?: string;
  is_active?: string;
}

export const GetHaulComapniesAPI =
  ({
    page,
    limit,
    setHasMore,
    search,
    id,
    created_at_start,
    created_at_end,
    updated_at_start,
    updated_at_end,
    is_active,
  }: GetHaulComapniesAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getHaulCompany", true);
    try {
      const response = await axios.get(`${APK_API_URL}/static-data/haul-company`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          id: id,
          created_at_start: created_at_start,
          created_at_end: created_at_end,
          updated_at_start: updated_at_start,
          updated_at_end: updated_at_end,
          is_active: is_active,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getHaulCompany", undefined);
        dispatchLoading(dispatch, "getHaulCompany", false);

        return result;
      } else {
        elseHandler(dispatch, "getHaulCompany", result);
        dispatchLoading(dispatch, "getHaulCompany", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getHaulCompany")(e);
      dispatchLoading(dispatch, "getHaulCompany", false);
    }
  };

export const AddHaulLocationAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "AddHaulLocationAPI", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.post(`${APK_API_URL}/static-data/haul-location`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "AddHaulLocationAPI", undefined);
        return result;
      } else {
        elseHandler(dispatch, "AddHaulLocationAPI", result);
      }
    } catch (e) {
      catchHandler(dispatch, "AddHaulLocationAPI")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "AddHaulLocationAPI", false);
    }
  };

interface GetHaulLocationsAPIProps {
  page?: number;
  limit?: number;
  setHasMore?: (hasMore: boolean) => void;
  id?: string;
  search?: string;
  created_at_start?: string;
  created_at_end?: string;
  updated_at_start?: string;
  updated_at_end?: string;
  is_active?: string;
}

export const GetHaulLocationsAPI =
  ({
    page,
    limit,
    setHasMore,
    search,
    id,
    created_at_start,
    created_at_end,
    updated_at_start,
    updated_at_end,
    is_active,
  }: GetHaulLocationsAPIProps) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getHaulLocations", true);
    try {
      const response = await axios.get(`${APK_API_URL}/static-data/haul-location`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          id: id,
          created_at_start: created_at_start,
          created_at_end: created_at_end,
          updated_at_start: updated_at_start,
          updated_at_end: updated_at_end,
          is_active: is_active,
        },
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        if (setHasMore) {
          setHasMore(result?.data?.data?.length === limit);
        }
        dispatchError(dispatch, "getHaulLocations", undefined);
        dispatchLoading(dispatch, "getHaulLocations", false);

        return result;
      } else {
        elseHandler(dispatch, "getHaulLocations", result);
        dispatchLoading(dispatch, "getHaulLocations", false);
      }
    } catch (e) {
      catchHandler(dispatch, "getHaulLocations")(e);
      dispatchLoading(dispatch, "getHaulLocations", false);
    }
  };

export const UpdateStorageContractAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "UpdateStorageContract", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/boat/storage-contract`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        if (onClose) onClose();

        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "UpdateStorageContract", undefined);
        return result;
      } else {
        elseHandler(dispatch, "UpdateStorageContract", result);
      }
    } catch (e) {
      catchHandler(dispatch, "UpdateStorageContract")(e);
    } finally {
      dispatchLoading(dispatch, "UpdateStorageContract", false);
    }
  };

export const GetStorageContractPDFAPI =
  ({ id, tz }: { id: string; tz: string }) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "getPdfFile", true);
    try {
      const response = await axios.get(`${APK_API_URL}/lead/store-contract/details/download`, {
        params: { id, tz },
        withCredentials: true,
        responseType: "blob",
      });

      const fileBlob = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(fileBlob);

      window.open(fileURL);

      dispatchError(dispatch, "getPdfFile", undefined);
      dispatchLoading(dispatch, "getPdfFile", false);

      return true;
    } catch (e) {
      catchHandler(dispatch, "getPdfFile")(e);
      dispatchLoading(dispatch, "getPdfFile", false);
    }
  };

export const DeleteStorageContractAPI =
  (data: any, onDelete?: () => void, onClose?: () => void) => async (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "DeleteStorageContract", true);

    try {
      const formattedData = requestPayloadBodyFormate(data);
      const response = await axios.delete(`${APK_API_URL}/boat/storage-contract`, {
        data: formattedData,
        withCredentials: true,
      });

      const result = responseDataFormate(response.data);

      if (result?.success) {
        onDelete?.();
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "DeleteStorageContract", undefined);
      } else {
        elseHandler(dispatch, "DeleteStorageContract", result);
      }
    } catch (error) {
      catchHandler(dispatch, "DeleteStorageContract")(error);
    } finally {
      dispatchLoading(dispatch, "DeleteStorageContract", false);
      onClose?.();
    }
  };

export const ManagerOverrideStorageContractAPI =
  (data: any, onClose?: any) =>
  async (dispatch: AppDispatch): Promise<any> => {
    dispatchLoading(dispatch, "ManagerOverrideContract", true);
    const formatedData = requestPayloadBodyFormate(data);

    try {
      const response = await axios.put(`${APK_API_URL}/boat/storage-contract/override`, formatedData, {
        withCredentials: true,
      });

      let result = responseDataFormate(response.data);
      if (result?.success) {
        dispatchToast(dispatch, "success", result?.message);
        dispatchError(dispatch, "ManagerOverrideContract", undefined);
        return result;
      } else {
        elseHandler(dispatch, "ManagerOverrideContract", result);
      }
    } catch (e) {
      catchHandler(dispatch, "ManagerOverrideContract")(e);
    } finally {
      if (onClose) onClose();
      dispatchLoading(dispatch, "ManagerOverrideContract", false);
    }
  };
